import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.css'; 
import poko_oh from '../assets/poko_oh.PNG';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page page">
      <div className="white-wrapper container">
        <h1>😵 Oops! Page Not Found</h1>
		<img className='poko' src={poko_oh} alt='poko oh' />
        <h5>We looked everywhere, but couldn’t find that page.</h5>
        <button className="game-btn" onClick={() => navigate('/')}>
          🏠 Back to Home
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
